export const supportOptions = [
  'Não consigo cadastrar um cartão',
  'Falha no pagamento do ticket',
  'Não consigo achar área para estacionar',
  'Outros',
];
